module.exports = __webpack_public_path__ + "img/pale_white.389d7280.svg";